import colors from "../base/colors";
import borders from "../base/borders";
import boxShadows from "../base/boxShadows";

import pxToRem from "../functions/pxToRem";

const { grey, gradients } = colors;
const { borderRadius } = borders;

const linearProgress = {
  styleOverrides: {
    root: {
      height: pxToRem(6),
      borderRadius: borderRadius.md,
      overflow: "hidden" as const,
      position: "relative" as const,
      backgroundColor: grey[200],
      boxShadow: boxShadows.inset,

      "&::before": {
        content: '""',
        position: "absolute" as const,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: `linear-gradient(45deg, transparent 33%, rgba(255,255,255,0.1) 33%, rgba(255,255,255,0.1) 66%, transparent 66%)`,
        backgroundSize: "25px 25px",
        animation: "progress-animation 1s linear infinite",
      },
    },

    bar: {
      borderRadius: borderRadius.md,
      transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    },

    colorPrimary: {
      backgroundColor: grey[200],

      "& .MuiLinearProgress-bar": {
        background: `linear-gradient(90deg, ${gradients.primary.main} 0%, ${gradients.primary.state} 100%)`,
      },
    },

    colorSecondary: {
      backgroundColor: grey[200],

      "& .MuiLinearProgress-bar": {
        background: `linear-gradient(90deg, ${gradients.secondary.main} 0%, ${gradients.secondary.state} 100%)`,
      },
    },

    buffer: {
      backgroundColor: "transparent",
    },

    dashed: {
      backgroundImage: `radial-gradient(${grey[300]} 0%, ${grey[300]} 16%, transparent 42%)`,
      backgroundSize: "10px 10px",
      backgroundPosition: "0 -23px",
    },
  },
};

export default linearProgress;
